module.exports = __webpack_public_path__ + "img/edit_text.7cddfdf.svg";